import React from 'react';

import ViewCarePlan from './ViewCarePlan';
import CreateCarePlan from './CreateCarePlan';
import EmptyCarePlan from './EmptyCarePlan';

export default function CarePlan({ telehealth }) {
  if ((telehealth.status === 'COMPLETED' || telehealth.status === 'CANCELED') && telehealth.carePlan) {
    return <ViewCarePlan carePlan={telehealth.carePlan} />
  } else if ((telehealth.status === 'COMPLETED' || telehealth.status === 'CANCELED') && !telehealth.hasOwnProperty('carePlan')) {
    return <EmptyCarePlan />;
  } else if (telehealth.status === 'READY' && telehealth.carePlan && telehealth.carePlan.status === 'publish') {
    return <ViewCarePlan carePlan={telehealth.carePlan} />
  } else if (
    (telehealth.status === 'READY' && !telehealth.hasOwnProperty('carePlan')) ||
    (telehealth.status === 'READY' && telehealth.carePlan && telehealth.carePlan.status === 'draft')
  ) {
    return <CreateCarePlan telehealth={telehealth} />
  } else {
    return null;
  }
}